import { supabase } from './supabaseClient';

export async function listUpdates() {
  if (!supabase) return [];
  const { data, error } = await supabase
    .from('app_updates')
    .select('*')
    .order('release_date', { ascending: false })
    .order('release_time', { ascending: false });
  
  if (error) {
    console.error('Error fetching updates:', error);
    return [];
  }
  return data;
}

export async function createUpdate(update) {
    if (!supabase) return null;
    const { data, error } = await supabase
        .from('app_updates')
        .insert(update)
        .select()
        .single();
    
    if (error) throw error;
    return data;
}
